import React from 'react'

const Welcome = () => {
    return (
        <div id="launching-page">
          <div className="bg-cont">
            <div className="intro">
                <i className="fas fa-dice fa-2x"></i>
                <span className="primary"> Welcome to SJ Games</span>
                <h1 className="secondary my-1">Online Gaming Platform. Enjoy playing unlimited free games. Your experience is our satisfaction. Have a good luck! Happy gaming guys...</h1>
            </div>
            <img src="https://cdn.fortniteinsider.com/wp-content/uploads/2018/04/30064748/Fortnite-skins-Fortnite-Raven-skin-1.png" alt="logo"></img>
          </div>
        </div>
    )
}

export default Welcome
